<template>
  <div class="page-content signage egl-dialog-elm">
    <h1 class="page-title" style="margin-bottom: 17px;">{{ $locale("cus.customizableItems")}}</h1>
    <el-form class="egl-elm egl-detail" :model="form" ref="cusForm" label-position="top">
      <!-- paper -->
      <el-row style="color: #181818;margin-bottom: 17px;"><el-col :span="24">{{ $locale('cus.paperTicket') }}</el-col></el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$locale('cus.logoForPrinting')">
            <p>{{ $locale("cus.imageTips") }}</p>
            <UploadContainer
              :fileMaxSize="1024 * 1024"
              :imageList="[form.paperTicketSetting.logoForPrint]"
              @onSuccess="({ response }) => uploadSuccess(response, 'paperTicketSetting', 'logoForPrint')"
              @onDelete="deletePhoto('paperTicketSetting', 'logoForPrint')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$locale('sideMenu.cinemaWebsite.notice')">
            <el-input type="textarea" :rows="5" :placeholder="$locale('cus.plsInputNotice')" v-model="form.paperTicketSetting.precautions" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$locale('cus.self-definedMessage(title)')">
            <el-input :placeholder="$locale('cinemaWebsite.news.form.title.plsInput')" v-model="form.paperTicketSetting.customizeMsgTitle" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$locale('cus.self-definedMessage(content)')">
            <el-input type="textarea" :rows="5" :placeholder="$locale('form.plsEnterMsg')" v-model="form.paperTicketSetting.customizeMsg" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- email -->
      <el-row style="color: #181818;margin-bottom: 17px;"><el-col :span="24">{{ $locale('cus.mailTicket') }}</el-col></el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$locale('cus.logo')">
            <UploadContainer
              :imageList="[form.mailTicketSetting.logoForPrint]"
              @onSuccess="({ response }) => uploadSuccess(response, 'mailTicketSetting', 'logoForPrint')"
              @onDelete="deletePhoto('mailTicketSetting', 'logoForPrint')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$locale('cus.self-definedMessage(title)')">
            <el-input :placeholder="$locale('cinemaWebsite.news.form.title.plsInput')" v-model="form.mailTicketSetting.customizeMsgTitle" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item :label="$locale('cus.self-definedMessage(content)')">
            <el-input type="textarea" :rows="5" :placeholder="$locale('form.plsEnterMsg')" v-model="form.mailTicketSetting.customizeMsg" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="detail-page-btn">
      <!-- <el-button class="egl-btn-white" @click="cancel_fn">{{ $locale("global.cancel") }}</el-button> -->
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm") }}</el-button>
    </div>
  </div>
</template>
<script>
import UploadContainer from "@/components/common/UploadContainer";
import { getCustomizeTicketService, updateCustomizeTicketService } from "@/helpers/service/api/customMessage";
import countDownAlert from "@/utils/countDownAlert";

export default {
  data() {
    return {
      form: {
        paperTicketSetting: {
          customizeMsg: "",
          customizeMsgTitle: "",
          logoForPrint: "",
          precautions: "",
        },
        mailTicketSetting: {
          customizeMsg: "",
          customizeMsgTitle: "",
          logoForPrint: "",
        }
      }
    };
  },
  created() {
    getCustomizeTicketService({
      cinemaId: window.localStorage.getItem("cinemaId")
    }).then(res => {
      if(res.data) {
        this.form = {
          paperTicketSetting: res.data.paperTicketSetting,
          mailTicketSetting: res.data.mailTicketSetting,
        };
      }
    });
  },
  methods: {
    uploadSuccess(res, type, key) {
      this.form[type][key] = res.data;
    },
    deletePhoto(type, key) {
      this.form[type][key] = "";
    },
    save_fn() {
      updateCustomizeTicketService({
        cinemaId: window.localStorage.getItem("cinemaId"),
        ...this.form,
      }).then(res => {
        if (res.data) {
          countDownAlert({ content: this.$locale("global.updateSuccessfully") });
        }
      });
    }
  },
  components: {
    UploadContainer,
  }
};
</script>